"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobxState = void 0;
var mobx_1 = require("mobx");
var MobxState = /** @class */ (function () {
    function MobxState() {
        this.reactions = [];
    }
    MobxState.prototype.autorun = function (view) {
        this.reactions.push((0, mobx_1.autorun)(view));
    };
    MobxState.prototype.reaction = function (expression, effect, opts) {
        this.reactions.push((0, mobx_1.reaction)(expression, effect, opts));
    };
    /**
     * Destroy any observers that this class has made.
     */
    MobxState.prototype.destroy = function () {
        this.reactions.forEach(function (r) { return r(); });
    };
    return MobxState;
}());
exports.MobxState = MobxState;
//# sourceMappingURL=mobx.js.map